import { logFormData } from 'shared/lib/logFormData';
import { sendEventOnSubmitCreditPurposeStep } from 'shared/lib/sendGAEvents';
import type { TFormAnalyticsEventsOverrides } from 'shared/types/TFormAnalyticsEventsOverrides';

import type { TCreditPurposeFormFields } from 'entities/creditForm';
import { sendStepsAnalyticsEvents, setCreditPurposeInfo } from 'entities/creditForm';
import { selectIsFullDealPage } from 'entities/siteSettings';

import { CreditPurposeInfoTexts } from 'features/UpdateCreditPurposeInfo/CreditPurposeInfo.texts';

export const submitCreditPurposeForm =
  (actualData: TCreditPurposeFormFields, analyticsOverrides?: TFormAnalyticsEventsOverrides): ThunkResult<void> =>
  async (dispatch, getState) => {
    logFormData('CreditPurposeInfo FormStep SubmitData', actualData);
    if (selectIsFullDealPage(getState())) {
      sendEventOnSubmitCreditPurposeStep({
        amount: actualData.amount,
        purpose: actualData.purpose?.label || '',
        term: actualData.period?.value || '',
      });
    }
    dispatch(sendStepsAnalyticsEvents([0], CreditPurposeInfoTexts, 'manual', analyticsOverrides));
    dispatch(setCreditPurposeInfo({ data: actualData, isFullFilled: true }));
  };
